import { Icon } from "../../../../elements/Icon";
import { styles } from "./SelectionCard.style";

const checkCircleFilledIcon = require("../../../../elements/Icon/images/check-circle-sky-blue.svg");

export interface SelectionCardProps {
  id: string;
  name: string;
  icon: string;
  description: string;
  isSelected: boolean;
  onChange: () => void;
}

export const SelectionCard = ({ id, name, icon, description, isSelected, onChange }: SelectionCardProps) => {
  return (
    <label htmlFor={id} className={styles.card()} data-selected={isSelected}>
      <input
        type="radio"
        id={id}
        name={name}
        checked={isSelected}
        onChange={onChange}
        className={styles.hiddenInput()}
      />
      <span className={styles.iconWrapper()}>
        <Icon icon={icon} size={32} role="presentation" />
      </span>
      <span className={styles.description()}>{description}</span>
      <span className={styles.checkIcon()} aria-hidden={!isSelected}>
        {isSelected && <Icon icon={checkCircleFilledIcon} size={24} role="presentation" />}
      </span>
    </label>
  );
};

SelectionCard.displayName = "SelectionCard";
